import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button';
import { DialogTitle } from '@openx/components-core/lib/Dialog/DialogTitle/DialogTitle';
import { useTranslation } from 'react-i18next';

export type ConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  item: string;
  title: string;
  bodyText?: string;
  confirmLabel?: string;
};

export const ConfirmationModal = ({
  isOpen,
  onClose,
  item,
  title,
  onDelete,
  bodyText,
  confirmLabel,
}: ConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle onClose={onClose}>{title}</DialogTitle>
      <DialogContent dividers>
        <Box>
          <Typography data-test="modal-info">{bodyText ?? t('You’re about to delete the following:')}</Typography>
          <Typography variant="body1Bold">{item}</Typography>
        </Box>

        <Typography
          sx={{
            mt: 2,
          }}
        >
          {t('Do you want to proceed?')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button data-test="cancel-button" onClick={onClose} variant="text">
          {t('Cancel')}
        </Button>

        <Button data-test="confirmation-button" onClick={onDelete} color="error">
          {confirmLabel ?? t('Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
